__turbopack_context__.v({
  "kpi_caption": "KPIContent-module-scss-module__SfdqiG__kpi_caption",
  "kpi_content": "KPIContent-module-scss-module__SfdqiG__kpi_content",
  "kpi_label": "KPIContent-module-scss-module__SfdqiG__kpi_label",
  "kpi_metric": "KPIContent-module-scss-module__SfdqiG__kpi_metric",
});
